import { PartnerQuery } from 'queries';
import React, { useCallback, useEffect, useState } from 'react';
import { MdOutlineMoreVert } from 'react-icons/md';
import { usePopper } from 'react-popper';

import { IPartner } from 'types';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';
import {
  thumbnail,
  disabledCover,
  info,
  name,
  description,
  moreButton,
  menu,
} from './styles';

interface Props {
  item: IPartner;
  selectedItem: IPartner | null;
  setSelectedItem: (item: IPartner | null) => void;
  setEditItem: (item: IPartner | null) => void;
}

function Item({ item, selectedItem, setSelectedItem, setEditItem }: Props) {
  const [referenceElement, setReferenceElement] =
    useState<HTMLDivElement | null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
    null,
  );
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'bottom-end',
  });
  const { mutateAsync: update } = PartnerQuery.useUpdate();

  const handleOff = useCallback(() => setSelectedItem(null), []);

  const handleDisable = async (disabled: boolean) => {
    if (!selectedItem) return;
    try {
      await update({ ...selectedItem, disabled, isNewFile: false });
      toast.success(
        disabled
          ? '파트너가 사용중지되었습니다.'
          : '파트너 사용중지가 해제되었습니다.',
      );
    } catch {
      toast.error(DEFAULT_ERROR_MESSAGE);
    }
    handleOff();
  };

  useEffect(() => {
    window.document.addEventListener('click', handleOff);

    () => window.document.removeEventListener('click', handleOff);
  }, []);

  return (
    <>
      <div css={thumbnail}>
        <img src={item.thumbnail} alt="" />
        {item.disabled && <div css={disabledCover}>사용중지</div>}
      </div>
      <div css={info}>
        <div>
          <p css={name}>{item.name}</p>
          <p css={description}>{item.description}</p>
        </div>
        <div
          ref={setReferenceElement}
          css={moreButton}
          role="button"
          aria-label="파트너 메뉴"
          onClick={(e) => {
            e.stopPropagation();
            setSelectedItem(item);
          }}
        >
          <MdOutlineMoreVert size={20} />
        </div>
      </div>
      {selectedItem?.id === item.id && (
        <div
          onClick={(e) => e.stopPropagation()}
          ref={setPopperElement}
          style={styles.popper}
          {...attributes.popper}
          css={menu}
        >
          <ul>
            <li
              onClick={() => {
                setSelectedItem(null);
                setEditItem(item);
              }}
            >
              수정
            </li>
            {item.disabled ? (
              <li onClick={() => handleDisable(false)}>사용중지 해제</li>
            ) : (
              <li onClick={() => handleDisable(true)}>사용중지</li>
            )}
          </ul>
        </div>
      )}
    </>
  );
}

export default Item;
